<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Daftar Dokumen Pengadaan" back_url="dokumen_pengadaan.dashboard" />
            <div class="p-col-12">
                <div class="card">
                    <DataTable ref="dt" :value="datatable.data" :lazy="true" data-key="id" :paginator="true" :rows="10"
                        :loading="datatable.loading" :total-records="datatable.totalRecords" filter-display="menu"
                        :global-filter-fields="datatable.globalFilterFields" v-model:filters="datatable.filters"
                        paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rows-per-page-options="[5, 10, 25]"
                        current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data"
                        @page="onPage($event)" @sort="onSort($event)" @filter="onFilter()">
                        <template #header>
                            <div class="table-header">
                                <div class="flex justify-content-between">
                                    <Button type="button" icon="pi pi-filter-slash" label="Clear"
                                        class="p-button-outlined" @click="clearFilter()" />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="datatable.filters['global'].value"
                                            @keydown.enter="onFilter()" placeholder="Keyword Search" />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="isi_doc" header="Keterangan Dokumen">
                            <template #body="slotProps">
                                {{ slotProps.data.isi_doc }}<br>

                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 150px;">
                            <template #body="slotProps">

                               <!-- {{ slotProps.data.tahap.nama_tahap === 'Hasil Pemilihan Penyedia' }}<br> -->
                                <div v-if="this.status == 'direvisi' || this.status == 'proses'">
                                    <Button icon="pi pi-check-square" :label="slotProps.data.tahap.nama_tahap"
                                        class="p-button-info p-button-sm mr-1" @click="set_data(slotProps.data)"
                                        v-if="slotProps.data.can.update && slotProps.data.tahap.tipe_tahap == 'set_data'" />
                                    <Button icon="pi  pi-spin pi-cog" :label="slotProps.data.tahap.nama_tahap"
                                        class="p-button-info p-button-sm mr-1" @click="custom_action(slotProps.data)"
                                        v-else-if="slotProps.data.can.update && slotProps.data.tahap.tipe_tahap == 'custom'" />
                                    <Button icon="pi pi-check-square" label="Approval"
                                        class="p-button-info p-button-sm mr-1" @click="approval(slotProps.data)"
                                        v-else-if="slotProps.data.can.update" />
                                    <Button icon="pi pi-check-square" label="Batal"
                                        class="p-button-danger p-button-sm mr-1"  @click="batal(slotProps.data)"
                                        v-if="slotProps.data.can.update && isPpk && slotProps.data.tahap.nama_tahap === 'Verifikasi Berita Acara Pemilihan Penyedia'"  />
                                </div>
                                <div v-if="this.status == 'revisi'">
                                    <Button icon="pi pi-check-square" label="Revisi"
                                        class="p-button-info p-button-sm mr-1" @click="revisi(slotProps.data)"
                                        v-if="slotProps.data.can.update" />
                                </div>
                                <div v-if="this.status == 'selesai'">
                                    <Button icon="pi pi-check-square" label="Batal"
                                        class="p-button-danger p-button-sm mr-1"  @click="batal(slotProps.data)"
                                        v-if="slotProps.data.can.update && isPpk && slotProps.data.tahap.nama_tahap === 'Hasil Pemilihan Penyedia' && slotProps.data.sanggah.length == 0"  />
                                </div>
                                <!---->
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <Dialog header="Approval" v-model:visible="displayModalApproval"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '70vw' }" :maximizable="true"
            :modal="true">
            <div v-if="loadingModalApproval">
                <ProgressBar mode="indeterminate" v-if="loadingModalApproval" />
            </div>
            <div v-else>
                <ApprovalPage v-on:closemodal="closeModal()" :dataViewDokumenPengadaan="this.approval_form_data"
                    :uuid="this.approval_form_data.uuid" :errors="[]" />
            </div>

        </Dialog>

        <DeleteDialog ref="deleteDialog" v-model:visible="deleteDialog" :loading="deletingModel" @delete="onDelete" />
        
        <!-- Add confirmation dialog for time-lock security warning -->
        <Dialog header="Konfirmasi Penguncian Data" v-model:visible="displaySecurityLockDialog" :style="{width: '450px'}" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem; color: var(--yellow-500)" />
                <span>Dengan menyetujui dokumen ini, <strong>data HPS dan file pendukung akan tidak dapat diakses oleh siapapun, termasuk admin sistem</strong> hingga tahap "Penawaran Pengadaan".</span>
            </div>
            <template #footer>
                <Button label="Batal" icon="pi pi-times" class="p-button-text" @click="displaySecurityLockDialog = false" />
                <Button label="Lanjutkan" icon="pi pi-check" class="p-button-warning" @click="proceedWithApproval" autofocus />
            </template>
        </Dialog>
    </div>

    <!-- konfirm batal dialog -->
    <dialog-modal :show="konfirmBataldDialog"  @close="tutup" :max-width="'7xl'" :style="{ width: '40rem' }">
      <template  #title>
        <div v-if="!['selesai','batal'].includes(dokumenPengadaan?.status)">
          Konfirmasi Batal
        </div>
        <div v-else>
          Informasi Pembatalan
        </div>
      </template>

      <template #content>
        <div v-if="!['batal'].includes(dokumenPengadaan?.status)" class="p-4">
            <div class="mb-4">
                <p>Apakah Anda yakin ingin membatalkan dokumen pengadaan ini?</p>
                 <div class="mt-2 text-yellow-600">
                      <i class="pi pi-info-circle mr-2"></i>
                      <span>Tindakan ini tidak dapat dibatalkan. Harap membaca syarat dan ketentuan pembatalan dan isi keterangan untuk melanjutkan.</span>
                  </div>
            </div>
             <!-- Add EULA section -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Syarat dan Ketentuan Pembatalan
                </label>
                <div 
                    class="border rounded-lg p-4 bg-gray-50 h-48 overflow-y-auto text-sm"
                    @scroll="handleEulaScroll($event)"
                >
                    <p class="mb-2">PERNYATAAN PERSETUJUAN PEMBATALAN
                        Sistem Pengadaan Universitas Diponegoro</p>
                    <p class="mb-2">Saya yang bertanda tangan di bawah ini:</p>
                    <table class="mb-2 w-full text-sm">
                        <tr>
                            <td class="font-bold">Nama</td>
                            <td>:</td>
                            <td>{{ $page.props.user.fullname }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">NIP</td>
                            <td>:</td>
                            <td>{{ $page.props.user.identity }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">Jabatan</td>
                            <td>:</td>
                            <td>Pejabat Pembuat Komitmen (PPK)</td>
                        </tr>
                        <tr>
                            <td class="font-bold">Unit Kerja</td>
                            <td>:</td>
                            <td>{{ $page.props.selected_role.unit_id }}</td>
                        </tr>
                    </table>
                    <p class="mb-2">dengan ini menyatakan bahwa:</p>
                    <div>
                        <section class="py-6">
                            <h2 class="font-bold">Pembatalan Kegiatan</h2>
                            <div class="p-jc-center">
                                <p>
                                    Saya memahami dan menyetujui bahwa keputusan pembatalan proses pengadaan dilakukan atas dasar pertimbangan objektif, sesuai dengan ketentuan peraturan perundang-undangan yang berlaku, serta dalam rangka menjaga prinsip akuntabilitas, efisiensi, dan efektivitas.
                                </p>
                            </div>
                            <h2 class="font-bold">Tanggung Jawab</h2>
                            <div class="p-jc-center">
                                <p>
                                    Saya bertanggung jawab sepenuhnya atas keputusan pembatalan ini, termasuk apabila di kemudian hari diperlukan klarifikasi, pembuktian, ataupun pertanggungjawaban administratif atau hukum terkait keputusan pembatalan ini.
                                </p>
                            </div>
                            <h2 class="font-bold">Keabsahan Alasan</h2>
                            <div class="p-jc-center">
                                <p>
                                    Saya menyatakan bahwa alasan pembatalan yang saya ajukan adalah sah, benar, dan dapat dipertanggungjawabkan. Alasan tersebut telah sesuai dengan fakta dan ketentuan yang berlaku.
                                </p>
                            </div>
                            <h2 class="font-bold">Pelepasan Tuntutan</h2>
                            <div class="p-jc-center">
                                <p>
                                    Saya menyatakan bahwa dengan ini melepaskan hak untuk menuntut pihak Universitas Diponegoro ataupun pihak lain yang terkait dalam sistem atas segala konsekuensi hukum, administratif, atau lainnya yang timbul dari pelaksanaan pembatalan ini.
                                </p>
                            </div>
                            <h2 class="font-bold">Persetujuan</h2>
                            <div class="p-jc-center">
                                <p>
                                    Dengan menandatangani pernyataan ini, saya menyetujui bahwa tindakan pembatalan ini tercatat secara elektronik di dalam sistem dan memiliki kekuatan hukum yang sama dengan pernyataan tertulis fisik.
                                </p>
                            </div>
                        </section>
                    </div>
                    <p class="mb-2">
                        Demikian pernyataan ini dibuat dengan sebenar-benarnya untuk digunakan sebagaimana mestinya.
                    </p>
                    <p class="mb-2">Semarang, {{ new Date().toLocaleDateString('id-ID', {day: 'numeric', month: 'long', year: 'numeric'}) }}</p>
                    <p class="mb-2">
                        <div class="mb-4" width="100%" height="200%">
                            <!-- <label class="block text-sm font-medium text-gray-700 mb-2">
                                Tanda Tangan Digital
                            </label> -->
                            <div class="border rounded-lg p-2 bg-gray-100">
                                <VueSignaturePad class="border-2 rounded-lg p-2 bg-white"
                                    ref="signaturePad"
                                    width="500px" height="500px"
                                    :options="padOptions" 
                                />
                            </div>
                            <div class="mt-2 flex space-x-2">
                                <button 
                                    @click="clearSignature"
                                    class="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Hapus Tanda Tangan
                                </button>
                            </div>
                        </div>
                    </p>
                    <p class="mb-2">Nama: {{ $page.props.user.fullname }}</p>
                    <p class="mb-2">NIP: {{ $page.props.user.identity }}</p>
                </div>
            </div>
            <div class="mb-4">
            <label class="block text-sm font-medium text-gray-700 mb-2">
                Keterangan Pembatalan
            </label>
                <textarea v-model="catatan" rows="4" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
    placeholder="Masukkan catatan..."></textarea>
            </div>
        </div>
        <div v-else-if="['selesai'].includes(dokumenPengadaan?.status) && dokumenPengadaan.tahap.nama_tahap==='Hasil Pemilihan Penyedia'" class="p-4">
            <div class="mb-4">
                <p>Apakah Anda yakin ingin membatalkan dokumen pengadaan ini?</p>
                 <div class="mt-2 text-yellow-600">
                      <i class="pi pi-info-circle mr-2"></i>
                      <span>Tindakan ini tidak dapat dibatalkan. Harap membaca syarat dan ketentuan pembatalan dan isi keterangan untuk melanjutkan.</span>
                  </div>
            </div>
             <!-- Add EULA section -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Syarat dan Ketentuan Pembatalan
                </label>
                <div 
                    class="border rounded-lg p-4 bg-gray-50 h-48 overflow-y-auto text-sm"
                    @scroll="handleEulaScroll($event)"
                >
                    <p class="mb-2">PERNYATAAN PERSETUJUAN PEMBATALAN
                        Sistem Pengadaan Universitas Diponegoro</p>
                    <p class="mb-2">Saya yang bertanda tangan di bawah ini:</p>
                    <table class="mb-2 w-full text-sm">
                        <tr>
                            <td class="font-bold">Nama</td>
                            <td>:</td>
                            <td>{{ $page.props.session_role.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">NIP</td>
                            <td>:</td>
                            <td>{{ $page.props.session_role.role_display_name }}</td>
                        </tr>
                        <tr>
                            <td class="font-bold">Jabatan</td>
                            <td>:</td>
                            <td>Pejabat Pembuat Komitmen (PPK)</td>
                        </tr>
                        <tr>
                            <td class="font-bold">Unit Kerja</td>
                            <td>:</td>
                            <td>{{ $page.props.session_role.nip }}</td>
                        </tr>
                    </table>
                    <p class="mb-2">dengan ini menyatakan bahwa:</p>
                    <div>
                        <section class="py-6">
                            <h2 class="doc-section-label">Pembatalan Kegiatan</h2>
                            <div class="doc-section-description">
                                <p>
                                    Saya memahami dan menyetujui bahwa keputusan pembatalan proses pengadaan dilakukan atas dasar pertimbangan objektif, sesuai dengan ketentuan peraturan perundang-undangan yang berlaku, serta dalam rangka menjaga prinsip akuntabilitas, efisiensi, dan efektivitas.
                                </p>
                            </div>
                            <h2 class="doc-section-label">Tanggung Jawab</h2>
                            <div class="doc-section-description">
                                <p>
                                    Saya bertanggung jawab sepenuhnya atas keputusan pembatalan ini, termasuk apabila di kemudian hari diperlukan klarifikasi, pembuktian, ataupun pertanggungjawaban administratif atau hukum terkait keputusan pembatalan ini.
                                </p>
                            </div>
                            <h2 class="doc-section-label">Keabsahan Alasan</h2>
                            <div class="doc-section-description">
                                <p>
                                    Saya menyatakan bahwa alasan pembatalan yang saya ajukan adalah sah, benar, dan dapat dipertanggungjawabkan. Alasan tersebut telah sesuai dengan fakta dan ketentuan yang berlaku.
                                </p>
                            </div>
                            <h2 class="doc-section-label">Pelepasan Tuntutan</h2>
                            <div class="doc-section-description">
                                <p>
                                    Saya menyatakan bahwa dengan ini melepaskan hak untuk menuntut pihak Universitas Diponegoro ataupun pihak lain yang terkait dalam sistem atas segala konsekuensi hukum, administratif, atau lainnya yang timbul dari pelaksanaan pembatalan ini.
                                </p>
                            </div>
                            <h2 class="doc-section-label">Persetujuan</h2>
                            <div class="doc-section-description">
                                <p>
                                    Dengan menandatangani pernyataan ini, saya menyetujui bahwa tindakan pembatalan ini tercatat secara elektronik di dalam sistem dan memiliki kekuatan hukum yang sama dengan pernyataan tertulis fisik.
                                </p>
                            </div>
                        </section>
                    </div>
                    <p class="mb-2">
                        Demikian pernyataan ini dibuat dengan sebenar-benarnya untuk digunakan sebagaimana mestinya.
                    </p>
                    <p class="mb-2">Semarang,  {{ new Date().toLocaleDateString() }}</p>
                    <p class="mb-2">
                        <div class="mb-4" width="50%" height="100%">
                            <!-- <label class="block text-sm font-medium text-gray-700 mb-2">
                                Tanda Tangan Digital
                            </label> -->
                            <div class="border rounded-lg p-2 bg-gray-100">
                                <VueSignaturePad class="border-2 rounded-lg p-2 bg-white"
                                    ref="signaturePad"
                                    width="500px" height="500px"
                                    :options="padOptions" 
                                />
                            </div>
                            <div class="mt-2 flex space-x-2">
                                <button 
                                    @click="clearSignature"
                                    class="inline-flex items-center px-3 py-1 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                    Hapus Tanda Tangan
                                </button>
                            </div>
                        </div>
                    </p>
                    <p class="mb-2">Nama: {{ $page.props.session_role.name }}</p>
                    <p class="mb-2">NIP: {{ $page.props.session_role.role_display_name }}</p>
                </div>
            </div>
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Keterangan Pembatalan
                </label>
                <textarea v-model="catatan" rows="4" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
    placeholder="Masukkan catatan..."></textarea>
            </div>
        </div>
        <div v-else class="p-4">
          <p>Dokumen pengadaan ini sudah dibatalkan dengan keterangan:</p>
          <p class="text-red-600 font-bold">{{ dokumenPengadaan.keterangan_pembatalan }}</p>
        </div>
      </template>

      <template #footer>
        <div class="flex justify-end space-x-4">
          <button
            @click="tutup"
            class="inline-flex items-center px-4 py-2 bg-gray-300 border border-transparent rounded-md font-semibold text-xs text-gray-700 uppercase tracking-widest hover:bg-gray-400 focus:outline-none focus:border-gray-400 focus:ring focus:ring-gray-200 active:bg-gray-300 disabled:opacity-25 transition"
          >
            <div v-if="['selesai','batal'].includes(dokumenPengadaan?.status)">
              Tutup
            </div>
            <div v-else>
              Tidak
            </div>
          </button>
          <button v-if="!['selesai','batal'].includes(dokumenPengadaan?.status)"
            @click="confirmBatal"  :disabled="!isFormValid"
            class="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
          >
            Iya
          </button>
          <button v-if="['selesai'].includes(dokumenPengadaan?.status) && dokumenPengadaan.tahap.nama_tahap==='Hasil Pemilihan Penyedia'"
            @click="confirmBatal"  :disabled="!isFormValid"
            class="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:ring focus:ring-blue-200 active:bg-blue-600 disabled:opacity-25 transition"
          >
            Iya
          </button>
        </div>
      </template>
    </dialog-modal>
</template>

<script>
import axios from "axios";
import { VueSignaturePad } from 'vue-signature-pad';
import AppLayout from "../../Layouts/AppLayout";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import ProgressBar from "primevue/progressbar";
import Column from "primevue/column";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import DeleteDialog from "../../Components/DeleteDialog";
import ApprovalPage from "./ApprovalPage.vue";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3';
import DialogModal from '@/Jetstream/DialogModal.vue'
import qs from 'qs';
import _ from 'lodash';

import { stringify, parse } from 'flatted';

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        AppMenuBar,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText,
        Dialog,
        ProgressBar,
        ApprovalPage,
        DialogModal,
        VueSignaturePad
    },
    props: {
        prosedur_id: String,
        kode_tahap: String,
        status: String,
    },
    computed: {
       isPpk() {
            const role = this.$page.props.session_role.role_display_name
            
            return ['ppk','administrator'].includes(role)
        },
        padOptions() {
            return {
                ...this.signaturePadOptions,
                onEnd: this.onSignatureEnd,
            }
        },
        isFormValid() {
            
            return this.catatan && 
                this.catatan.trim().length > 0 && 
               !this.signatureIsEmpty && 
                this.eulaRead;
        }
    },
    data() {
        return {
            form_data: null,
            displayModalApproval: false,
            loadingModalApproval: false,
            approval_form_data: null,
            datatable: {
                prosedur_id: this.prosedur_id,
                kode_tahap: this.kode_tahap,
                status: this.status,
                loading: true,
                totalRecords: 0,
                data: null,
                globalFilterFields: ['isi_doc'],
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                    // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
                },
                lazyParams: {}
            },
            menuItems: [
                {
                    label: 'Tambah User',
                    icon: 'pi pi-fw pi-plus',
                    class: 'p-button-primary p-button-raised',
                    command: () => {
                        this.$inertia.get(this.route('users.create'));
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
            konfirmBataldDialog: false,
            // disabledActive: false,
            catatan: null,
            signatureIsEmpty: true,        
            eulaRead: false,
            signaturePadOptions: {
                penColor: 'black',
                backgroundColor: 'rgba(255,255,255,0)',
                minWidth: 1.2,         // garis lebih halus
                throttle: 16,          // performa tinggi
            },
            displaySecurityLockDialog: false,
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    async mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            prosedur_id: this.prosedur_id,
            kode_tahap: this.kode_tahap,
            status: this.status,
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields
        };
        this.loadLazyData();
    },
    methods: {
        async loadLazyData() {
            this.datatable.loading = true;

            try {
                const res = axios.get(route(`/dokumen_pengadaan/datatable_list_monitoring/`), {
                    params: {
                        prosedur_id: this.prosedur_id,
                        kode_tahap: this.kode_tahap,
                        status: this.status,
                        dt_params: JSON.stringify(this.datatable.lazyParams),
                        searchable_columns: JSON.stringify(this.datatable.globalFilterFields),
                    },
                });

                this.datatable.data = res.data.payload.data;
                this.datatable.totalRecords = res.data.payload.total;
                this.datatable.loading = false;
            } catch (e) {
                this.datatable.loading = false;

                this.datatable.data = [];
                this.datatable.totalRecords = 0;
                // loading.value = false;
            }
            this.datatable.loading = true;
            this.datatableService.getData(this.route('dokumen_pengadaan.datatable_list_monitoring'), {
                dt_params: JSON.stringify(this.datatable.lazyParams),
                searchable_columns: JSON.stringify(this.datatable.globalFilterFields)

            }).then(data => {
                this.datatable.data = data.payload.data;
                // console.log('DATA is ready');
                this.datatable.totalRecords = data.payload.total;
                this.datatable.loading = false;
            });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
            // this.datatable.lazyParams.filters = this.datatable.filters;
            // console.log('huehue');
            // this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters =
            {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
            };

            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // console.log(this.datatable.lazyParams);
            // this.loadLazyData();
        },
        onSort(event) {
            // console.log(event);
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // this.loadLazyData();
        },
        approval(data) {

            this.approval_form_data = null;
            this.loadingModalApproval = true;
            this.displayModalApproval = true;
            axios.get(route('dokumen_pengadaan.get_detail_dokumen_pengadaan'), {
                params: {
                    uuid: data.uuid
                }
            }).then(res => {
                this.approval_form_data = res.data.data;
                this.approval_form_data.uuid = data.uuid;
                this.loadingModalApproval = false;
                if (data.tahap.kode_tahap == 'verifikasi_dokumen_pemilihan_1f') {
                    this.displaySecurityLockDialog = true;
                }
            });

        },
        proceedWithApproval() {
            this.displaySecurityLockDialog = false;
            this.displayModalApproval = true;
        },
        revisi(data) {
            var query_string = window.location.search;
            // remove the ?
            query_string = query_string.substring(1);
            var back_url_param = qs.parse(query_string);
            // console.log(data.id);
            // return;

            this.$inertia.visit(this.route('dokumen_pengadaan.revisi', {
                id: data.id,
                back_url_param: back_url_param
            }));

            // alert();
            return;

        },
        set_data(data) {
            var query_string = window.location.search;
            // remove the ?
            query_string = query_string.substring(1);
            var back_url_param = qs.parse(query_string);
            // console.log(data.id);
            // return;

            this.$inertia.visit(this.route('dokumen_pengadaan.set_data', {
                id: data.id,
                back_url_param: back_url_param
            }));

            // alert();
            return;

        },
        custom_action(data) {
            var query_string = window.location.search;
            // remove the ?
            query_string = query_string.substring(1);
            var back_url_param = qs.parse(query_string);
            // console.log(data.id);
            // return;

            this.$inertia.visit(this.route('dokumen_pengadaan.custom_action', {
                id: data.id,
                back_url_param: back_url_param
            }));

            // alert();
            return;

        },
        closeModal() {
            this.displayModalApproval = false;
            this.loadLazyData();
        },
        showDeleteDialog(model) {
            this.selectedModel = model;
            this.deleteDialog = true;
        },
        onDelete() {
            this.deletingModel = true;
            this.$inertia.delete(this.route('dokumen_pengadaan.destroy', this.selectedModel.id), {
                onSuccess: () => {
                    this.deletingModel = false;
                    this.deleteDialog = false;
                    this.loadLazyData();
                    this.$refs.deleteDialog.onClose();
                }
            })
        },
        batal(dokumenPengadaan) {
            this.konfirmBataldDialog = true;
            this.dokumenPengadaan = dokumenPengadaan;
            // tunggu satu siklus render supaya ukuran dialog sudah final
            this.$nextTick(() => {
                this.$refs.signaturePad.resizeCanvas()
            })
        },
        tutup() {
            this.konfirmBataldDialog = false;
            this.signatureIsEmpty = true
            this.eulaRead = false;
            this.$nextTick(() =>{ 
                this.$refs.signaturePad?.clearSignature()
            });
            this.catatan = null;
            // this.disabledActive = false;
           /*  if (this.$refs.signaturePad) {
                this.$refs.signaturePad.clearSignature();
            } */
        },
        onSignatureEnd() {
            // Perbarui status – ini TRIGGER re-render computed
            this.signatureIsEmpty = this.$refs.signaturePad.isEmpty()
        },
        async confirmBatal() {
            if (!this.isFormValid) return;
            
            this.konfirmBataldDialog = false;
            this.isFormValid = true;

            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

            /* 2️⃣  turn Base64 into a Blob/File so we can use FormData */
            const res = await fetch(data)
            const blob = await res.blob()
            const file = new File([blob], `signature-${this.dokumenPengadaan.id}-${this.dokumenPengadaan.isi_doc}-${Date.now()}.png`, {
                type: blob.type
            })

            /* 3️⃣  POST to Laravel API */
            const form = new FormData()
            form.append('signature', file)
            form.append('catatan', this.catatan) 
            form.append('eula', this.eulaRead ? 1 : 0)
            
            try {
                const response = await axios.post(route('dokumen-pengadaan.batal-proses', this.dokumenPengadaan.id),form); //
                
                    this.$toast.add({
                    severity: 'success',
                    summary: 'Berhasil',
                    detail: response.data.message,
                    life: 3000,
                    });
                    this.tutup(); 
                    this.loadLazyData();
                } catch (error) {
                    // Log detailed error information
                    console.error('Error detail:', {
                        message: error.message,
                        response: error.response?.data,
                        status: error.response?.status
                    });
                    if (error.response?.status === 422) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.response.data.message,
                        life: 3000,
                    });
                    } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Terjadi kesalahan saat membatalkan dokumen pengadaan',
                        life: 3000,
                    });
                    }
                }finally {
                    this.konfirmBataldDialog = false;
                    this.disabledActive = false;
                    this.eulaRead = false;
                    this.catatan = null;
                }
        },
        clearSignature() {
            this.$refs.signaturePad.clearSignature();
             this.signatureIsEmpty = true
        },
        handleEulaScroll(event) {
            const element = event.target;
            const reachedBottom = Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 1;
            
            if (reachedBottom) {
                this.eulaRead = true;
            }
        },
    }
}
</script>

<style scoped></style>
